module.exports = __webpack_public_path__ + "static/media/DP.b1648f62.png";